"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalcModule = void 0;
const math_1 = require("../math");
class CalcModule {
    constructor(context) {
        this.context = context;
    }
    async alignPriceToTick(instrumentAddr, price) {
        return (0, math_1.alignPriceToTick)(price);
    }
    async getWadAtTick(instrumentAddr, tick) {
        return math_1.TickMath.getWadAtTick(tick);
    }
    async getTickAtPWad(instrumentAddr, price) {
        return math_1.TickMath.getTickAtPWad(price);
    }
    async getWadAtTicks(instrumentAddr, lowerTick, upperTick) {
        return {
            lowerPrice: math_1.TickMath.getWadAtTick(lowerTick),
            upperPrice: math_1.TickMath.getWadAtTick(upperTick),
        };
    }
    async sqrtX96ToWad(instrumentAddr, sqrtPX96) {
        return (0, math_1.sqrtX96ToWad)(sqrtPX96);
    }
}
exports.CalcModule = CalcModule;
